export default "__VITE_ASSET__BgUOM1D___"